<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div class="card" v-if="company">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Company Prices Analysis'}}</strong>
          <span v-if="hist_prices.length>0">
            (
            <b>From</b>
            : {{getFormattedDate(hist_prices[0]["date"])}} -
            <b>To</b>
            : {{getFormattedDate(hist_prices[(hist_prices.length-1)]["date"])}})
          </span>
        </div>
        <div class="col-md-5">
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-primary" @click.prevent="editCompany(company)">
              <i :title="'Edit'" class="fa fa-edit cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-secondary" :to="{name: 'pTrends', props: { isIndividual: 0 } }">
              <i :title="'P Trends'" class="fa fa-area-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-dark" to="/company-price-analysis">
              <i :title="'Company Price Graph'" class="fa fa-line-chart cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-info" to="/rawdata">
              <i :title="'Raw Data'" class="fa fa-list cwhite"></i>
            </router-link>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-warning" @click.prevent="viewCalculatedData(company)" >
              <i :title="'Calculated Data'" class="fa fa-calculator cwhite"></i>
            </a>
          </div>
          <div class="mr5 pull-right">
            <a class="btn btn-sm btn-small btn-success" @click.prevent="showDetailView(company)">
              <i :title="'View Details'" class="fa fa-eye cwhite"></i>
            </a>
          </div>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <v-select
              :options="companyList"
              :placeholder="'Select Company'"
              :label="'companyname'"
              v-model="selComp"
              @input="getCompRawData"
            >
              <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
            </v-select>
          </div>
        </div>
        <!-- <div class="col-md-3" v-if="hist_prices.length>0">
          <div class="form-group">
            <label class="control-label">
              <b>Start Date:</b>
            </label>
            <label class="control-label">{{getDate(hist_prices[0]["date"])}}</label>
          </div>
        </div>
        <div class="col-md-3" v-if="hist_prices.length>0">
          <div class="form-group">
            <label class="control-label">
              <b>End Date:</b>
            </label>
            <label class="control-label">{{getDate(hist_prices[(hist_prices.length-1)]["date"])}}</label>
          </div>
        </div>-->
      </div>
      <div class="row mb5">
        <div class="col-md-6 br">
          <div class="table-responsive"  v-dragscroll="true" v-if="hist_prices.length>0">
            <table class="table table-bordered fonts11">
              <thead>
                <tr>
                  <th colspan="2">Historical Price Analysis</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-bold">Total Days</td>
                  <td>{{hist_prices.length}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Min</td>
                  <td>
                    {{getFixed(rawData[0].min_value)}}
                    <b>[ {{getFormattedDate(rawData[0].min_value_date[0])}} ]</b>
                  </td>
                </tr>
                <tr>
                  <td class="text-bold">Max</td>
                  <td>
                    {{getFixed(rawData[0].max_value)}}
                    <b>[ {{getFormattedDate(rawData[0].max_value_date[0])}} ]</b>
                  </td>
                </tr>
                <tr>
                  <td class="text-bold">Avg</td>
                  <td>{{getFixed(rawData[0].avg_value)}}</td>
                </tr>
                <tr>
                  <td class="text-bold">SD</td>
                  <td>{{getFixed(rawData[0].stdev_value)}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Percent Variation</td>
                  <td>{{getFixed(rawData[0].percentage_variation_)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="table-responsive" v-dragscroll="true">
            <table class="table table-bordered fonts11" v-if="decrease_data.length>0">
              <thead>
                <tr>
                  <th colspan="2">Difference Analysis</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-bold">No. of days price has fallen</td>
                  <td>{{rawData[0].decrease_data.count}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Min</td>
                  <td>
                    {{getFixed(rawData[0].decrease_data.min_value)}}
                    <b>[ {{getFormattedDate(rawData[0].decrease_data.min_value_date[0])}} ]</b>
                  </td>
                </tr>
                <tr>
                  <td class="text-bold">Max</td>
                  <td>
                    {{getFixed(rawData[0].decrease_data.max_value)}}
                    <b>[ {{getFormattedDate(rawData[0].decrease_data.max_value_date[0])}} ]</b>
                  </td>
                </tr>
                <tr>
                  <td class="text-bold">Avg</td>
                  <td>{{getFixed(rawData[0].decrease_data.avg_value)}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Min % Declined</td>
                  <td>{{getFixed(rawData[0].decrease_data.min_diff_percentage)}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Max % Declined</td>
                  <td>{{getFixed(rawData[0].decrease_data.max_diff_percentage)}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Avg % Declined</td>
                  <td>{{getFixed(rawData[0].decrease_data.avg_diff_percentage)}}</td>
                </tr>
                <!-- <tr>
                    <td class="text-bold">PV</td>
                    <td>{{getFixed(rawData.percentage_variation_)}}</td>
                </tr>-->
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 br">
          <!-- <h4 class="subtitle">Historical Analysed data</h4><br/> -->
          <!-- <div class="row">
            <div class="col-md-4" v-if="rawData.min_value">
              <div class="form-group">
                <label class="control-label">
                  <b>Min:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.min_value)}}</label>
              </div>
            </div>
            <div class="col-md-4" v-if="rawData.max_value">
              <div class="form-group">
                <label class="control-label">
                  <b>Max:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.max_value)}}</label>
              </div>
            </div>
            <div class="col-md-4" v-if="rawData.avg_value">
              <div class="form-group">
                <label class="control-label">
                  <b>Avg:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.avg_value)}}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4" v-if="rawData">
              <div class="form-group">
                <label class="control-label">
                  <b>Total days:</b>
                </label>
                <label class="control-label">{{hist_prices.length}}</label>
              </div>
            </div>
            <div class="col-md-4" v-if="rawData.stdev_value">
              <div class="form-group">
                <label class="control-label">
                  <b>SD:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.stdev_value)}}</label>
              </div>
            </div>
            <div class="col-md-4" v-if="rawData.percentage_variation_">
              <div class="form-group">
                <label class="control-label">
                  <b>PV:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.percentage_variation_)}}</label>
              </div>
            </div>
          </div>-->
          <div class="row mb5">
            <div class="col-md-9"></div>
            <div class="col-md-3" v-if="hist_prices.length>0">
              <download :tableId="'historical'" :fileName="'historical'"></download>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered fonts11" v-if="hist_prices" id="historical">
              <thead>
                <tr>
                  <th v-for="field in tableColumns" v-bind:key="'title'+field.title">{{field.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in hist_prices" v-bind:key="'tdraw'+index">
                  <td
                    v-for="field in tableColumns"
                    v-bind:key="'tdrawcol'+field.title+index"
                    :class="(field.isNumeric)? 'text-right':''"
                  >
                    <span v-if="field.title==='date'">{{getDate(row[field.title])}}</span>
                    <span v-else-if="field.title==='percentage'">{{getFixed(row[field.title])}} %</span>
                    <span v-else>{{getFixed(row[field.title])}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <!-- <div class="row">
            <div class="col-md-7" v-if="rawData.decrease_data">
              <div class="form-group">
                <label class="control-label">
                  <b>No. of days price fallen:</b>
                </label>
                <label class="control-label">{{rawData.decrease_data.count}}</label>
              </div>
            </div>
            <div class="col-md-5" v-if="rawData.decrease_data">
              <div class="form-group">
                <label class="control-label">
                  <b>Avg % Declined:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.decrease_data.avg_diff_percentage)}}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4" v-if="rawData.decrease_data">
              <div class="form-group">
                <label class="control-label">
                  <b>Min:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.decrease_data.min_value)}}</label>
              </div>
            </div>
            <div class="col-md-4" v-if="rawData.decrease_data">
              <div class="form-group">
                <label class="control-label">
                  <b>Max:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.decrease_data.max_value)}}</label>
              </div>
            </div>
            <div class="col-md-4" v-if="rawData.decrease_data">
              <div class="form-group">
                <label class="control-label">
                  <b>Avg:</b>
                </label>
                <label class="control-label">{{getFixed(rawData.decrease_data.avg_value)}}</label>
              </div>
            </div>
          </div>-->
          <div class="row mb5">
            <div class="col-md-9"></div>
            <div class="col-md-3" v-if="decrease_data.length>0">
              <download :tableId="'fallen_price'" :fileName="'fallen_prices'"></download>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered fonts11" v-if="decrease_data" id="fallen_price">
              <thead>
                <tr>
                  <th
                    v-for="field in tableFields"
                    v-bind:key="'title111'+field.title"
                  >{{field.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in decrease_data" v-bind:key="'td-red'+index">
                  <td
                    v-for="field in tableFields"
                    v-bind:key="'td-red'+field.title+index"
                    :class="(field.isNumeric)? 'text-right':''"
                  >
                    <span v-if="field.title==='date'">{{getDate(row[field.title])}}</span>
                    <span v-else-if="field.title==='percentage'">{{getFixed(row[field.title])}} %</span>
                    <span v-else>{{getFixed(row[field.title])}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import spinner from "@/components/spinner";
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  // props: ["company"],
  mixins: [commonMixins],
  created() {
    this.getCompaniesList();
  },
  methods: {
    getRawData() {
      this.rawData = {};
      this.hist_prices = [];
      this.tableFields = [];
      this.tableColumns = [];
      this.decrease_data = [];
      (this.companies = []),
        (this.selectedCompanies = []),
        (this.isCompSel = true),
        (this.isCompared = false);
      let myself = this;
      http.post(
        this.rawDataApi,
        { co_code: this.company.co_code },
        (error, response) => {
          if (response.length > 0) {
            this.rawData = response;
            // console.log(response.decrease_data.data);
            console.log(Object.keys(response[0].data[0]));
            if (response[0].data.length > 0) {
              this.hist_prices = response[0].data;
              // this.hist_prices = this.sorted_fields_date_asc(
              //   response.data,
              //   "date"
              // );
              var tableFields1 = Object.keys(response[0].data[0]);
              tableFields1.forEach((val, key) => {
                if (val !== "_id") {
                  this.tableColumns.push({
                    title: val,
                    name: this.getLabel(val),
                    isNumeric: 1
                  });
                }
              });
            }
            console.log(this.hist_prices, this.tableColumns);
            setTimeout(() => {
              if (response[0].decrease_data.data.length > 0) {
                // this.decrease_data = this.sorted_fields_date_asc(response[0].decrease_data.data, "date");
                this.decrease_data = response[0].decrease_data.data;
                var tableFields = Object.keys(
                  response[0].decrease_data.data[0]
                );
                tableFields.forEach((val, key) => {
                  this.tableFields.push({
                    title: val,
                    name: this.getLabel(val),
                    isNumeric: 1
                  });
                });
              }
              console.log(this.decrease_data, this.tableFields);
            }, 100);
            //TODO:: add company updates into our array in future
          }
        }
      );
    },
    getCompanies() {
      var companies = [];
      this.rawData.balance_sheet.forEach(function(val, index) {
        if (val.coname && val.coname !== null)
          companies.push({ id: val.coname, value: val.coname });
      });
      this.companies = companies;
    },
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          if (!localStorage.getItem("selcomp")) {
            _this.selComp = _this.companyList[0];
            localStorage.setItem("selcomp", JSON.stringify(_this.selComp));
          } else {
            _this.selComp = JSON.parse(localStorage.getItem("selcomp"));
          }
          console.log("Selected Comp", typeof _this.selComp);
          // setTimeout(() => {
          _this.company.companyname = _this.selComp.companyname;
          _this.company.co_code = _this.selComp.co_code;
          // });
        }
      });
    },
    getCompRawData() {
      console.log("Get RawData", this.selComp);
      if (this.selComp !== "") {
        localStorage.setItem("selcomp", JSON.stringify(this.selComp));
        this.company.companyname = this.selComp.companyname;
        this.company.co_code = this.selComp.co_code;
        console.log(
          "Company",
          this.company.co_code,
          "=>",
          this.company.companyname
        );
        // this.getTabData(this.selRowInd, {}, {});
        this.getRawData();
      }
    }
  },
  data() {
    return {
      selTab: "",
      companyList: [],
      lastSelectItem: {},
      selComp: "",
      company: { co_code: "", companyname: "" },
      tableFields: [],
      rawDataApi: "companyWisePriceAnalysis",
      rawData: {},
      selRowInd: 0,
      companies: [],
      selectedCompanies: [],
      tableColumns: [],
      tableRows: [],
      decrease_data: [],
      hist_prices: []
    };
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/companyPriceAnalysis.vue